export const getRouteMutationKey = ({ routeId }: { routeId?: string }) => {
  return [`drivers_route`, routeId];
};
